export function defaultProps(theme){
    return {
        MuiButton: {
            defaultProps:{
                color: 'inherit'
            }
        }
    }
}